import { utils, ColumnAlignment } from '@easydata/core';
import { CellRendererType } from "./easy_grid_cell_renderer";
var DEFAULT_WIDTH_STRING = 250;
var ROW_NUM_WIDTH = 60;
export var GridColumnAlign;
(function (GridColumnAlign) {
    GridColumnAlign[GridColumnAlign["NONE"] = 1] = "NONE";
    GridColumnAlign[GridColumnAlign["LEFT"] = 2] = "LEFT";
    GridColumnAlign[GridColumnAlign["CENTER"] = 3] = "CENTER";
    GridColumnAlign[GridColumnAlign["RIGHT"] = 4] = "RIGHT";
})(GridColumnAlign || (GridColumnAlign = {}));
function MapAlignment(alignment) {
    switch (alignment) {
        case ColumnAlignment.Left:
            return GridColumnAlign.LEFT;
        case ColumnAlignment.Center:
            return GridColumnAlign.CENTER;
        case ColumnAlignment.Right:
            return GridColumnAlign.RIGHT;
        default:
            return GridColumnAlign.NONE;
    }
}
var GridColumn = /** @class */ (function () {
    function GridColumn(column, grid, isRowNum) {
        if (isRowNum === void 0) { isRowNum = false; }
        this._label = null;
        this._description = null;
        //public left: number;
        this.align = GridColumnAlign.NONE;
        this.isVisible = true;
        this.isRowNum = false;
        this.dataColumn = column;
        this.grid = grid;
        var widthOptions = grid.options.columnWidths || {};
        if (column) {
            if (column.style.alignment) {
                this.align = MapAlignment(column.style.alignment);
            }
            this.width = (widthOptions && widthOptions[this.type]) ? widthOptions[this.type].default : DEFAULT_WIDTH_STRING;
            this.cellRenderer = this.grid.cellRendererStore.getDefaultRenderer(column.type);
            this._description = column.description;
        }
        else if (isRowNum) {
            this.isRowNum = true;
            this.width = (widthOptions && widthOptions.rowNumColumn) ? widthOptions.rowNumColumn.default : ROW_NUM_WIDTH;
            this._label = '';
            this.cellRenderer = this.grid.cellRendererStore.getDefaultRendererByType(CellRendererType.NUMBER);
        }
        if (grid && grid.options && grid.options.onGetCellRenderer) {
            this.cellRenderer = grid.options.onGetCellRenderer(this, this.cellRenderer) || this.cellRenderer;
        }
    }
    Object.defineProperty(GridColumn.prototype, "label", {
        get: function () {
            return this._label ? this._label : this.isRowNum ? '' : this.dataColumn.label;
        },
        set: function (value) {
            this._label = this.label;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(GridColumn.prototype, "description", {
        /** Get column description. */
        get: function () {
            return this._description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumn.prototype, "type", {
        get: function () {
            return this.dataColumn ? this.dataColumn.type : null;
        },
        enumerable: true,
        configurable: true
    });
    return GridColumn;
}());
export { GridColumn };
var GridColumnList = /** @class */ (function () {
    function GridColumnList(columnList, grid) {
        this.items = [];
        this.grid = grid;
        this.sync(columnList);
    }
    GridColumnList.prototype.sync = function (columnList, hasRowNumCol) {
        if (hasRowNumCol === void 0) { hasRowNumCol = true; }
        this.clear();
        var rowNumCol = new GridColumn(null, this.grid, true);
        this.add(rowNumCol);
        if (!hasRowNumCol) {
            rowNumCol.isVisible = false;
        }
        if (columnList) {
            for (var _i = 0, _a = columnList.getItems(); _i < _a.length; _i++) {
                var column = _a[_i];
                var col = new GridColumn(column, this.grid);
                if (this.grid.options.onSyncGridColumn) {
                    this.grid.options.onSyncGridColumn(col);
                }
                this.add(col);
            }
        }
    };
    Object.defineProperty(GridColumnList.prototype, "count", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnList.prototype.add = function (col) {
        var index = this.items.length;
        this.items.push(col);
        return index;
    };
    GridColumnList.prototype.put = function (index, col) {
        if (index >= 0 && index < this.items.length) {
            this.items[index] = col;
        }
    };
    GridColumnList.prototype.move = function (col, newIndex) {
        var oldIndex = this.items.indexOf(col);
        if (oldIndex >= 0 && oldIndex != newIndex)
            utils.moveArrayItem(this.items, oldIndex, newIndex);
    };
    GridColumnList.prototype.get = function (index) {
        if (index >= 0 && index < this.items.length) {
            return this.items[index];
        }
        else {
            return null;
        }
    };
    //    public getIndex(name: string) : number {
    //        return this.mapper[name];
    //    }
    GridColumnList.prototype.getItems = function () {
        return this.items;
    };
    GridColumnList.prototype.removeAt = function (index) {
        var col = this.get(index);
        this.items.splice(index, 1);
        //delete this.mapper[col.name];
    };
    GridColumnList.prototype.clear = function () {
        this.items = [];
        //this.mapper = {};
    };
    return GridColumnList;
}());
export { GridColumnList };
//# sourceMappingURL=easy_grid_columns.js.map